<div class="dialog-title">Switch Account</div>
<div>
  <form
    class="search-account"
    id="input-search"
    style="position: relative; margin-bottom: 10px"
  >
    <input
      type="text"
      class="form-ctrl"
      placeholder="Search project here ..."
      [(ngModel)]="value"
      name="searchCompany"
      autofocus
      #searchCompanyInput
    />
    <a
      id="closeButton"
      class="close-search-button"
      style="position: absolute"
      matRipple
      matRippleRadius="20"
      matRippleCentered="true"
      (click)="closeSearch()"
      aria-label="search"
    >
      <i class="ti-close"></i>
    </a>
  </form>

  <mat-list class="searchBar" style="margin-bottom: 10px" id="company-listing">
    <mat-list-item class="container">
      <span matLine
        >Company Listing (<span class="count"
          >{{ accountList?.length || 0 }}</span
        >)</span
      >
      <button
        mat-icon-button
        aria-label="search"
        (click)="initSearch(); searchCompanyInput.focus()"
      >
        <mat-icon>search</mat-icon>
      </button>
    </mat-list-item>
  </mat-list>
</div>

<mat-card class="core-list scrollable">
  <mat-list style="margin-right: 10px">
    <ng-container>
      <mat-list-item
        *ngFor="let account of accountList | SearchFilter : value;  let i = index"
        (click)="switchAccount(account.id)"
      >
        <mat-icon> chevron_right </mat-icon>
        <div class="xsTitle-f" matLine>{{account.name}}</div>

        <mat-divider></mat-divider>
      </mat-list-item>
    </ng-container>
  </mat-list>
</mat-card>
